<template>
  <div :class="$style.root">
    <div :class="[$style.mainSections, { [$style.hasRightContent]: $slots.right }]">
      <div class="flex flex-col w-full pe-component-padding-small">
        <slot />
      </div>
      <slot name="right" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style module lang="scss">
.root {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: max-content auto;

  .mainSections {
    height: 100%;
    width: 100%;
    display: grid;

    &.hasRightContent {
      grid-template-columns: 385px auto;
    }
  }
}
</style>
